import { render } from "./TonKeeper.vue?vue&type=template&id=4efaf410"
import script from "./TonKeeper.vue?vue&type=script&lang=js"
export * from "./TonKeeper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__